export const SUPPORTED_LANGUAGES = [
  { code: 'el', name: 'Greek', default: true },
  { code: 'en', name: 'English', default: false },
  { code: 'es', name: 'Spanish', default: false }
]